/**
 * Guess if a passed string is an email
 */
export function isEmail(value: string): boolean {
  if (typeof value !== 'string') {
    return false;
  }

  return /^[\w.\-+]+@[\w.-]+\.\w+$/i.test(value);
}
